import { render, staticRenderFns } from "./ReturnConfiguration.vue?vue&type=template&id=1c55cf8d"
import script from "./ReturnConfiguration.vue?vue&type=script&lang=js"
export * from "./ReturnConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports